var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorNodeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C16 2.89543 16.8954 2 18 2H20C21.1046 2 22 2.89543 22 4V6C22 7.10457 21.1046 8 20 8H18C17.7229 8 17.4589 7.94363 17.2189 7.84173L14.8417 10.2189C14.9436 10.4589 15 10.7229 15 11V13C15 14.1046 14.1046 15 13 15H11C10.7229 15 10.4589 14.9436 10.2189 14.8417L7.84173 17.2189C7.94363 17.4589 8 17.7229 8 18V20C8 21.1046 7.10457 22 6 22H4C2.89543 22 2 21.1046 2 20V18C2 16.8954 2.89543 16 4 16H6C6.27714 16 6.54111 16.0564 6.78107 16.1583L9.15827 13.7811C9.05637 13.5411 9 13.2771 9 13V11C9 9.89543 9.89543 9 11 9H13C13.2771 9 13.5411 9.05637 13.7811 9.15827L16.1583 6.78107C16.0564 6.54111 16 6.27714 16 6V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorNodeAlt);
export default __webpack_public_path__ + "static/media/vector-node-alt.ed8aa13d8da7b76cc4841c9fc8d1f449.svg";
export { ForwardRef as ReactComponent };